import { addMetaDataProperties } from "./serializer/add-metaData-properties";
import { removeDateTimeType } from "./serializer/remove-datetime-type";

export function configureSerializer() {
    removeDateTimeType();
    addMetaDataProperties();
}